import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Response } from '@angular/http';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, AlertService, JhiLanguageService } from 'ng-jhipster';

import { Energyflat } from './energyflat.model';
import { EnergyflatPopupService } from './energyflat-popup.service';
import { EnergyflatService } from './energyflat.service';
import { Marketday, MarketdayService } from '../marketday';

@Component({
    selector: 'jhi-energyflat-dialog',
    templateUrl: './energyflat-dialog.component.html'
})
export class EnergyflatDialogComponent implements OnInit {

    energyflat: Energyflat;
    authorities: any[];
    isSaving: boolean;

    marketdays: Marketday[];
    constructor(
        public activeModal: NgbActiveModal,
        private jhiLanguageService: JhiLanguageService,
        private alertService: AlertService,
        private energyflatService: EnergyflatService,
        private marketdayService: MarketdayService,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['energyflat']);
    }

    ngOnInit() {
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.marketdayService.query().subscribe(
            (res: Response) => { this.marketdays = res.json(); }, (res: Response) => this.onError(res.json()));
    }
    clear() {
        this.activeModal.dismiss('cancel');
    }

    save() {
        this.isSaving = true;
        if (this.energyflat.id !== undefined) {
            this.energyflatService.update(this.energyflat)
                .subscribe((res: Energyflat) =>
                    this.onSaveSuccess(res), (res: Response) => this.onSaveError(res));
        } else {
            this.energyflatService.create(this.energyflat)
                .subscribe((res: Energyflat) =>
                    this.onSaveSuccess(res), (res: Response) => this.onSaveError(res));
        }
    }

    private onSaveSuccess(result: Energyflat) {
        this.eventManager.broadcast({ name: 'energyflatListModification', content: 'OK'});
        this.isSaving = false;
        this.activeModal.dismiss(result);
    }

    private onSaveError(error) {
        try {
            error.json();
        } catch (exception) {
            error.message = error.text();
        }
        this.isSaving = false;
        this.onError(error);
    }

    private onError(error) {
        this.alertService.error(error.message, null, null);
    }

    trackMarketdayById(index: number, item: Marketday) {
        return item.id;
    }
}

@Component({
    selector: 'jhi-energyflat-popup',
    template: ''
})
export class EnergyflatPopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private energyflatPopupService: EnergyflatPopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe((params) => {
            if ( params['id'] ) {
                this.modalRef = this.energyflatPopupService
                    .open(EnergyflatDialogComponent, params['id']);
            } else {
                this.modalRef = this.energyflatPopupService
                    .open(EnergyflatDialogComponent);
            }
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/energyflat/energyflat-dialog.component.ts